import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const withdrawalHistorySchema = z.object({
  /** 出金識別ID */
  uuid: z.string(),
  /** アセット名 */
  asset: z.string(),
  /** 出金アカウントのID */
  account_uuid: z.string(),
  /** 出金数量 */
  amount: decimalSchema,
  /** 出金手数料 */
  fee: decimalSchema,
  /** 出金先アドレスにつけたラベル(暗号資産の時のみ) */
  label: z.string().optional(),
  /** 出金先アドレス(暗号資産の時のみ) */
  address: z.string().optional(),
  /** ネットワーク名(暗号資産の時のみ) */
  network: z.string().optional(),
  /** 出金先宛先タグまたはメモ(タグまたはメモを指定した暗号資産の出金時のみ) */
  destination_tag: z.union([z.number(), z.string()]).optional(),
  /** 出金トランザクションID(暗号資産の時のみ) */
  txid: z.string().nullable().optional(),
  /** 出金先銀行(法定通貨の時のみ) */
  bank_name: z.string().optional(),
  /** 出金先銀行支店(法定通貨の時のみ) */
  branch_name: z.string().optional(),
  /** 出金先口座種別(法定通貨の時のみ) */
  account_type: z.string().optional(),
  /** 出金先口座番号(法定通貨の時のみ) */
  account_number: z.string().optional(),
  /** 出金先口座名義(法定通貨の時のみ) */
  account_owner: z.string().optional(),
  /** 出金状態 */
  status: z.union([
    z.literal('CONFIRMING'),
    z.literal('EXAMINING'),
    z.literal('SENDING'),
    z.literal('DONE'),
    z.literal('REJECTED'),
    z.literal('CANCELED'),
    z.literal('CONFIRM_TIMEOUT'),
  ]),
  /** リクエスト日時UNIXタイムスタンプ(ミリ秒) */
  requested_at: z.number().int(),
})

export const responseSchema = z.object({
  data: z.object({
    withdrawals: z.array(withdrawalHistorySchema),
  }),
})
